import script from "./Error404Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Error404Page.vue?vue&type=script&setup=true&lang=js"

import "./Error404Page.vue?vue&type=style&index=0&id=f0610a8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0610a8c"]])

export default __exports__